import axios from 'axios';

// Use same domain in production (avoids CORS), env var in development
const BACKEND_URL = process.env.NODE_ENV === 'production' 
  ? window.location.origin 
  : process.env.REACT_APP_BACKEND_URL;
const API_BASE = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API_BASE,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor - adds token for authenticated requests
api.interceptors.request.use((config) => {
  // Only add token for non-supplier routes (suppliers use their own auth)
  if (!config.headers.Authorization) {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
  }
  return config;
});

// Response interceptor - handles 401 errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      const currentPath = window.location.pathname;
      
      // Skip if already on a login/register page
      if (currentPath.includes('/login') || currentPath.includes('/register')) {
        return Promise.reject(error);
      }

      // Google sign-in callback handles its own errors (no forced redirect)
      if (currentPath.includes('/auth/callback') || error.config?.url?.includes('/auth/google/session')) {
        return Promise.reject(error);
      }
      
      // Handle admin 401
      if (currentPath.includes('/admin')) {
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        window.location.href = '/admin/login';
        return Promise.reject(error);
      }
      
      // Handle supplier 401 - let SupplierLayout handle it
      // Don't do anything here for suppliers - their auth is managed by SupplierLayout
      if (currentPath.includes('/supplier')) {
        return Promise.reject(error);
      }
      
      // Handle factura 401
      if (currentPath.includes('/factura')) {
        window.location.href = '/factura/dashboard';
        return Promise.reject(error);
      }
      
      // Handle regular user 401
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default api;